import { FpSharedResourcesSection } from './FpSharedResourcesSection';

export function SettingsTab() {
  return (
    <div data-testid="settings-tab" className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Settings & Configuration</h2>
        <p className="text-gray-600 mt-1">Platform configuration and admin preferences</p>
      </div>

      <FpSharedResourcesSection />
    </div>
  );
}
